const { POSTAL_CODE_FORMAT } = require('../../config/shared/countryConfig');

module.exports.validatePostalCode = (country, postalCode) => {
  const postalCodeRegex = POSTAL_CODE_FORMAT[country.toLowerCase()];

  return postalCodeRegex ? postalCodeRegex.test(postalCode) : true;
};
